import { useEffect } from 'react';
import { useNotifier } from 'redux/modules/notifier';
import { useSnackbar } from 'components/notistack';

let displayed: any[] = [];

const Notifier = () => {
  const { removeSnackbar, state } = useNotifier();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const notifications = state.notifications || [];

  const storeDisplayed = (id: any) => {
    displayed = [...displayed, id];
  };

  const removeDisplayed = (id: any) => {
    displayed = [...displayed.filter((key) => id !== key)];
  };

  useEffect(() => {
    notifications.forEach(({ key, message, options = {}, dismissed = false }: any) => {
      if (dismissed) {
        // dismiss snackbar using notistack
        closeSnackbar(key);
        return;
      }

      // do nothing if snackbar is already displayed
      if (displayed.includes(key)) return;

      // display snackbar using notistack
      enqueueSnackbar(message, {
        key,
        ...options,
        onClose: (event: any, reason: any, myKey: any) => {
          if (options.onClose) {
            options.onClose(event, reason, myKey);
          }
        },
        // @ts-expect-error ts-migrate(6133) FIXME: 'event' is declared but its value is never read.
        onExited: (event: any, myKey: any) => {
          // removen this snackbar from redux store
          removeSnackbar(myKey);
          removeDisplayed(myKey);
        },
      });

      // keep track of snackbars that we've displayed
      storeDisplayed(key);
    });
  }, [notifications, closeSnackbar, enqueueSnackbar]);

  return null;
};

export default Notifier;
